import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="rounded-lg border border-primary-200 bg-primary-50 px-5 py-10 md:px-10 md:py-12">
      <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
            <i className="ri-group-line text-sm"></i>
            吃瓜群开放加入中
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            一个人吃瓜太寂寞，一群人围观才叫热闹
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            订阅瓜田日报，每天一封短邮件，把当天最值得看的事件、最犀利的热评和最新鲜的神回复送到你手上。
            不刷屏、不带节奏，只挑好看的给你。
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
          <Link
            to="/about"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-send-line mr-2 text-lg"></i>
            立即订阅日报
          </Link>
          <Link
            to="/comments"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            先逛逛神评榜
          </Link>
        </div>
      </div>
    </section>
  );
}